import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field, getIn } from 'formik';
import { Form } from '@contently/toolkit';

const validate = value => {
  if (!value || !value.length) {
    return 'Custom question label is required';
  }
  return null;
};

const QuestionField = ({ question, index, setFieldValue }) => (
  <Fragment>
    <Form.Label htmlFor={`questions[${index}].label`}>Question Field</Form.Label>
    <Field validate={validate} name={`questions[${index}].label`}>
      {({ field, form: { errors, touched } }) => {
        const error = getIn(errors, field.name);
        const touch = getIn(touched, field.name);
        return (
          <Form.ErrorWrapper touched={touch} error={error}>
            <Form.InputWithCheckbox
              inputProps={{ id: field.name, name: field.name }}
              placeholder="Your question..."
              checkboxLabel="Required"
              onCheckboxChange={event => {
                setFieldValue(`questions[${index}].required`, event);
              }}
              inputValue={question.label}
              onInputChange={event => {
                setFieldValue(`questions[${index}].label`, event.target.value);
              }}
              checkboxValue={question.required}
            />
          </Form.ErrorWrapper>
        );
      }}
    </Field>
  </Fragment>
);

QuestionField.propTypes = {
  question: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    required: PropTypes.bool
  }).isRequired,
  index: PropTypes.number.isRequired,
  setFieldValue: PropTypes.func.isRequired
};

export default QuestionField;



// WEBPACK FOOTER //
// ./app/javascript/app/components/questions/QuestionField.jsx